import React from 'react';
import styled from 'styled-components';
import ChevronDown16 from '@/public/images/seo/ChevronDown16.svg';
import ChevronUp16 from '@/public/images/seo/ChevronUp16.svg';

interface ViewMoreProps {
    handleViewMoreClick: () => void;
    text?: string;
}

const ViewMore: React.FC<ViewMoreProps> = ({ handleViewMoreClick, text }) => {
    return (
        <ViewMoreWrapper onClick={() => handleViewMoreClick()}>
            {text ? text : 'view more'}
            {text?.includes('less') ? <ChevronUp16 /> : <ChevronDown16 />}
        </ViewMoreWrapper>
    );
};

const ViewMoreWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    color: #121212;

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
`;

export default ViewMore;
